// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"GlobalHeader_globalHeader__q1A5a"};